// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ps-z","tooltipWrapper":"Qs-z","icon":"Rs-z","tooltip":"Ss-z","content":"Ts-z"};